import { render } from "./NewProspectBtn.vue?vue&type=template&id=80e1b452"
import script from "./NewProspectBtn.vue?vue&type=script&lang=js"
export * from "./NewProspectBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__